import { Component, OnInit, Input } from '@angular/core';
import { R5DevicesComponent } from '../r5-devices/r5-devices.component';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import * as numeral from 'numeral';
import * as _ from 'underscore';
@Component({
	selector: 'app-r5-sem-coversions',
	templateUrl: './r5-sem-coversions.component.html',
	styleUrls: ['../r5-devices/r5-devices.component.css']
})
export class R5SemCoversionsComponent extends R5DevicesComponent implements OnInit {
	public tooltipOptions = {
		position: 'top',
		animation: 'fade',
		arrowSize: 'small',
		distance: 0,
		offset: 0,
		arrow: true,
		size: 'small',
		duration: 750,
		scale: 'small',
		dynamicTitle: true,
		theme: 'r5-sem-coversions'
	};
	@Input() multichartconfigurations: any;
	public totalCoversions;
	public totalAllConversions;
	public conversionRate;
	public totalClicks;
	public metricObject;
	public isR9: boolean = false;

	constructor(analyticsService: AnalyticsService, analyticsDataModel: AnalyticsDataModel) {
		super(analyticsService, analyticsDataModel);
	}

	ngOnInit(): void {
		this.multichartconfigurations = JSON.parse(decodeURI(this.multichartconfigurations));
		this.isR9 = this.analyticsDataModel.config.version === 'R9' ? true : false;
		super.ngOnInit();
	}
	processDonutData(responseData: any): void {
		if (responseData && responseData.length > 0) {
			this.donutData = [];
			if (responseData?.length <= 5) {
				responseData = responseData;
			} else {
				let tempAllConversions = 0;
				let tempConversionaction = '';
				let tempCoversions = 0;
				let tempclicks = 0;

				for (let i = 4; i < responseData?.length; i++) {
					tempAllConversions += Number(responseData[i]['all_conversions']);
					tempCoversions += Number(responseData[i]['conversions']);
					tempclicks = Number(responseData[i]['clicks']);
				}
				let tempDataArray = {
					all_conversions: tempAllConversions.toString(),
					conversion_action: 'Additional',
					conversions: tempCoversions.toString(),
					clicks: tempclicks.toString(),
					tooltip: 'All other conversion actions.'
				};
				let updatedRespData = responseData.splice(0, 4);
				updatedRespData.splice(4, 0, tempDataArray);
				responseData = updatedRespData;
				this.responseData = responseData;
			}

			this.responseData = _.map(this.responseData, (item) => {
				return {
					conversion_action: item['conversion_action'],
					conversions: item['conversions'],
					clicks: item['clicks'],
					tooltip: item['tooltip'],
					all_conversions: item['all_conversions']
				};
			});
			const currentMetricTotal = this.responseData.reduce((s, f) => {
				return s + Number(f['conversions']);
			}, 0);

			_.each(this.responseData, (item) => {
				const frmt =
					numeral((Number(item['conversions']) / currentMetricTotal) * 100).format('0, 0.00') === '100.00'
						? '0'
						: '0,0.00';
				const percentage = numeral((Number(item['conversions']) / currentMetricTotal) * 100).format(frmt);
				const donutTotal = currentMetricTotal - Number(item['conversions']);

				const obj = [
					{
						percent: percentage,
						conversions: Number(item['conversions']),
						donutTotal: donutTotal,
						title: item['conversion_action'],
						tooltip: item['tooltip'],
						clicks: item['clicks']
					}
				];

				this.donutData.push(obj);
			});

			this.totalCoversions = currentMetricTotal.toLocaleString();
			this.totalAllConversions = this.responseData
				.reduce((s, f) => {
					return s + Number(f['all_conversions']);
				}, 0)
				.toLocaleString();
			this.totalClicks = this.donutData[0][0]['clicks'].toLocaleString();
			const frmt_conversionRate =
				numeral((this.totalCoversions / numeral(this.donutData[0][0]['clicks'])._value) * 100).format('0, 0.00') ===
				'100.00'
					? '0'
					: '0,0.00';
			this.conversionRate = numeral((currentMetricTotal / numeral(this.donutData[0][0]['clicks'])._value) * 100).format(
				frmt_conversionRate
			);
			this.donutData = this.donutData.filter((obj) => {
				return obj[0]['conversions'] != 0;
			});
			this.metricObject = [
				{
					name: 'Conversions',
					value: this.totalCoversions,
					tooltip:
						'An action that’s counted when someone interacts with your ad or free product listing, then takes an action you’ve defined as valuable to your business, such as a purchase or a phone call.'
				},
				{
					name: 'Conversion Rate',
					value: this.conversionRate + '%',
					tooltip: 'The average number of conversions per ad interaction, as a percentage.'
				},
				{
					name: 'All Conversions',
					value: this.totalAllConversions,
					tooltip:
						'A calculation of all the conversions that Google Ads drives for your business, including any actions being excluded from your tracking metrics.'
				}
			];
		}
	}
}
